/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetTestDto } from './GetTestDto';
import {
    GetTestDtoFromJSON,
    GetTestDtoFromJSONTyped,
    GetTestDtoToJSON,
} from './GetTestDto';
import type { GetKeyTestDto } from './GetKeyTestDto';
import {
    GetKeyTestDtoFromJSON,
    GetKeyTestDtoFromJSONTyped,
    GetKeyTestDtoToJSON,
} from './GetKeyTestDto';

/**
 * 
 * @export
 * @interface GetIndicatorTestDto
 */
export interface GetIndicatorTestDto {
    /**
     * 
     * @type {string}
     * @memberof GetIndicatorTestDto
     */
    id: string;
    /**
     * 
     * @type {GetTestDto}
     * @memberof GetIndicatorTestDto
     */
    test?: GetTestDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetIndicatorTestDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetIndicatorTestDto
     */
    mode?: GetIndicatorTestDtoModeEnum;
    /**
     * 
     * @type {GetKeyTestDto}
     * @memberof GetIndicatorTestDto
     */
    keyTest?: GetKeyTestDto | null;
}


/**
 * @export
 */
export const GetIndicatorTestDtoModeEnum = {
    NumberOfCorrectAnswers: 'NumberOfCorrectAnswers',
    SumOfPresentationTime: 'SumOfPresentationTime',
    WeightedSum: 'WeightedSum',
    WeightedValueSum: 'WeightedValueSum'
} as const;
export type GetIndicatorTestDtoModeEnum = typeof GetIndicatorTestDtoModeEnum[keyof typeof GetIndicatorTestDtoModeEnum];


/**
 * Check if a given object implements the GetIndicatorTestDto interface.
 */
export function instanceOfGetIndicatorTestDto(value: object): value is GetIndicatorTestDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetIndicatorTestDtoFromJSON(json: any): GetIndicatorTestDto {
    return GetIndicatorTestDtoFromJSONTyped(json, false);
}

export function GetIndicatorTestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIndicatorTestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'test': json['test'] == null ? undefined : GetTestDtoFromJSON(json['test']),
        'name': json['name'] == null ? undefined : json['name'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'keyTest': json['keyTest'] == null ? undefined : GetKeyTestDtoFromJSON(json['keyTest']),
    };
}

export function GetIndicatorTestDtoToJSON(value?: GetIndicatorTestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'test': GetTestDtoToJSON(value['test']),
        'name': value['name'],
        'mode': value['mode'],
        'keyTest': GetKeyTestDtoToJSON(value['keyTest']),
    };
}

